import {DOCUMENT} from '@angular/common';
import {Inject} from '@angular/core';
import {Renderer2} from '@angular/core';
import {Router} from '@angular/router';
import {MainService} from 'src/app/Services/service.service';
import {DTOSubRegion} from './../../../api/WickedApiClient';
import {Component, OnInit, ViewEncapsulation, ViewChild, ElementRef} from '@angular/core';
import {AuthClient, LoginModel, SubRegion} from 'src/app/api/WickedApiClient';
import {CookieService} from 'ngx-cookie-service';
import Player from "@vimeo/player";
import {ActivatedRoute} from '@angular/router';
import {SearchRouteService} from './../../../Services/searchroute.service';
import {GeolocationService} from './../../../Services/geolocation.service';
import {HomeComponent} from './../../../home/home.component';

function compare(a, b) {
    if(a.name < b.name) {
        return -1;
    }
    if(a.name > b.name) {
        return 1;
    }
    return 0;
}

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class MobileHomeComponent extends HomeComponent implements OnInit {

    _mostPopularCities: SubRegion[] = [];

    get showWickedVideo(): boolean {
        return this.service.showStartVideo;
    }
    set showWickedVideo(val: boolean) {
        this.service.showStartVideo = val;
    }

    @ViewChild("wickedvideo", {static: false}) wickedVideo: ElementRef;

    constructor(public service: MainService, public geolocationService: GeolocationService,
        public cookieService: CookieService, public route: Router, activeRoute: ActivatedRoute, searchRouteService: SearchRouteService, private renderer2: Renderer2, @Inject(DOCUMENT) private _document) {
        super(service, geolocationService, cookieService, route, activeRoute, searchRouteService,);
        service.pageName = "Search";
    }

    ngOnInit() {
        super.ngOnInit();




        //   const s = this.renderer2.createElement('script');
        //  s.onload = this.loadNextScript.bind(this);
        //  s.type = 'text/javascript';
        //  s.src = 'https://poweredby.jads.co/js/jads.js'; // Defines someGlobalObject
        //  s.text = ``;
        //  this.renderer2.appendChild(this._document.body, s);
    }

    loadNextScript() {
        console.log("SCRIPT LOADED");
        // const s = this.renderer2.createElement('script');
        // s.setAttribute('data-cfasync', 'false');
        // s.text = `(adsbyjuicy = window.adsbyjuicy || []).push({'adzone':929577});`
        // this.renderer2.appendChild(this._document.body, s);
    }


    ngAfterViewInit(): void {

        //const adsbyjuicy = (window["adsbyjuicy"] || []).push({'adzone':929577});
        // console.log(window);
        // console.log(window["adsbyjuicy"]);

        if(this.showWickedVideo) {
            let player = new Player(this.wickedVideo.nativeElement, {id: 373344002, byline: false, portrait: false, title: false, autoplay: true, width: this.wickedVideo.nativeElement.offsetWidth, height: this.wickedVideo.nativeElement.offsetHeight});
            player.ready().catch(e => {
                this.showWickedVideo = false;
            });

            player.on("play", () => {
                this.cookieService.set("hiddenVideo", "true");
            });

            player.on("ended", () => {
                this.showWickedVideo = false;
            });

            player.on("error", () => {
                this.showWickedVideo = false;
            });
        }
    }

}
